import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxRadioContext } from './CheckboxRadioContext';

/* eslint-disable react/prop-types */
const CheckboxRadio = (props) => {
  const { name, checkedValues, onChange, inputType } = React.useContext(
    CheckboxRadioContext
  );
  const { value, ...rest } = props;

  const attributes = {
    checked: false,
  };

  let isChecked = false;

  if (undefined !== checkedValues) {
    isChecked = Array.isArray(checkedValues)
      ? checkedValues.indexOf(value) >= 0
      : checkedValues === value;
    attributes.checked = isChecked;
  }

  if (typeof onChange === 'function') {
    const onChangeParams = {
      checked: !attributes.checked,
      isRadio: inputType === 'radio',
    };
    attributes.onChange = onChange.bind(null, value, onChangeParams);
  }

  return (
    <input
      type={inputType}
      name={name}
      role={inputType}
      aria-checked={isChecked}
      {...attributes}
      {...rest}
    />
  );
};

CheckboxRadio.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]).isRequired
};

export default CheckboxRadio;
